import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';


const KEY_ACTION = ActionType.DeleteDevPlanItemRequest;
const ACTIONS    = [
  ActionType.DeleteDevPlanItemRequest,
  ActionType.DeleteDevPlanItemResponse,
  ActionType.DeleteDevPlanItemError,
];


type Payload = boolean;

type Meta = {
  devItemId: number;
};


/**
 * Dispatch this action to delete the dev plan items made by the user
 */
export const deleteDevPlanItemAction = (
  participantId: number,
  projectId: number,
  devItemId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.DeleteDevPlanItem,
  headers:  { 'content-type': 'application/json', 'accept': 'application/json' },
  body:     state => JSON.stringify({
    participantId,
    projectId,
    devItemId,
    languageId: state.locale.lang.languageId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { devItemId }),
  bailout:  state => !!getLoading(state, KEY_ACTION, devItemId),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const devItemId = action.meta.devItemId;
  if (isLoading) {
    return addLoading(state, KEY_ACTION, devItemId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, devItemId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, devItemId);

  return R.assocPath(
    ['devPlan', 'items'],
    successState.devPlan?.items?.filter(item => item.devItemId !== devItemId) ?? [],
    R.dissocPath(['devPlan', 'actionsByItemId', `${devItemId}`], successState),
  );
};


export const deleteDevPlanItemReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
